import React from 'react';

export default function SecurityWrapper({ children }) {
  return (
    <div className='flex-grow z-5 w-full max-w-2xl mx-auto flex'>
        {children}
    </div>
  );
}
